import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { EventDTO, ProductUpdaterDTO, Sale, Watch } from 'src/app/api/models';
import { LogisticService, ManagementService } from 'src/app/api/services';
import { ColumnViewerService } from 'src/app/api/services/column-viewer.service';
import { LOGISTIC_STATUS_DICTIONARY, LOGISTIC_STATUS_VALUES, LogisticStatus } from 'src/app/enums/logistic-status-enum';
import { RoleEnum } from 'src/app/enums/role-enum';
import { SaleStatus } from 'src/app/enums/sale-status-enum';
import { SharedService } from 'src/app/services/shared.service';
import { EditDialogComponent } from '../dialogs/edit-dialog/edit-dialog.component';

@Component({
  selector: 'app-table-bulgari',
  templateUrl: './table-bulgari.component.html',
  styleUrls: ['./table-bulgari.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TableBulgariComponent implements OnInit, OnDestroy, AfterViewInit {

  constructor(
    private dialog: MatDialog,
    private translateService: TranslateService,
    private sharedService: SharedService,
    private logisticService: LogisticService,
    private managementService: ManagementService,
    public columnViewerService: ColumnViewerService,
  ) { }

  @Input() pageIndex = 0;
  @Input() sortRules?: Sort;
  @Input() tableCols: any;
  @Input() totalCount: number = 0;
  @Input() data: any;
  @Input() responseProduct: any;
  @Input() searchResult: any;
  @Input() idTable = '';
  @Input() limit: number = 10;

  @ViewChild('tableRef') tableRef!: ElementRef;
  @ViewChild(MatPaginator, {}) paginator?: MatPaginator;

  @Output() fetchDataHandler = new EventEmitter();
  @Output() updateDataHandler = new EventEmitter();

  @Output() iconAction = new EventEmitter();

  isLoadingPage = false;
  event?: EventDTO;
  dataSource = new MatTableDataSource([]);

  scrollingLeft: boolean = false;
  scrollingRight: boolean = false;

  addedScrollListener = false;
  tableMaxHeight = window.innerHeight;

  public loadingRow: number = -1;

  private _logisticStatusMenu: LogisticStatus[] = [
    LogisticStatus.ARRIVED,
    LogisticStatus.NOT_ARRIVED,
  ]

  private _liveStatusMenu: LogisticStatus[] = [
    LogisticStatus.OUT,
    LogisticStatus.BROKEN,
    LogisticStatus.WEAR,
  ]

  public getLogisticStatusMenu(status: LogisticStatus): LogisticStatus[] {
    return LOGISTIC_STATUS_DICTIONARY.get(status) || [];
  }

  public get keys() {
    return this.tableCols?.map(({ key }: any) => key);
  }

  public isDisabledLiveStatusButton(element: any, key: String) {
    return !element.canUpdateLogisticStatus || this.loadingRow >= 0;
  }

  ngOnInit(): void {
    this.event = this.sharedService.event;
  }

  ngOnDestroy(): void {
    if (this.tableRef.nativeElement) {
      this.tableRef.nativeElement.removeEventListener('scroll', this.handleHorizontalScroll)
    }
  }

  ngAfterViewInit() {
    const paginatorIntl = this.paginator?._intl;
    if (paginatorIntl) {
      paginatorIntl.nextPageLabel = '';
      paginatorIntl.previousPageLabel = '';
      paginatorIntl.firstPageLabel = '';
      paginatorIntl.lastPageLabel = '';
    }
    if (this.idTable === "products") {
      this.dataSource = this.data.map((elem: any) => {
        return elem;
      });
    } else {
      this.dataSource = this.data;
    }
    if (this.tableRef.nativeElement && !this.addedScrollListener) {
      this.addedScrollListener = true;
      this.tableRef.nativeElement.addEventListener('scroll', this.handleHorizontalScroll)
    }
    this.setTableHeight();
  }

  //Calcolo l'altezza massima della tabella per consentire lo scroll con l'header fissato.
  setTableHeight() {
    try {
      let { top } = this.tableRef.nativeElement.getBoundingClientRect();
      let windowHeight = window.innerHeight;
      let headerHeight = document.getElementById('app-header')?.clientHeight ?? 0;
      let footerHeight = document.getElementById('app-footer')?.clientHeight ?? 0;
      this.tableMaxHeight = windowHeight - headerHeight - footerHeight - 30;
    }
    catch (err) {
      console.log(err);
    }
  }

  handleHorizontalScroll = ((event: any) => {
    const { scrollLeft, scrollWidth, offsetWidth } = event.target;
    //Gestione flag per lo scroll di sinistra
    if (scrollLeft === 0 && this.scrollingLeft) {
      this.scrollingLeft = false;
    } else if (!this.scrollingLeft) {
      this.scrollingLeft = true;
    }
    //Gestione flag per lo scroll di destra
    if (Math.ceil(offsetWidth + scrollLeft) === scrollWidth && this.scrollingRight) {
      this.scrollingRight = false;
    } else if (!this.scrollingRight && Math.ceil(offsetWidth + scrollLeft) < scrollWidth) {
      this.scrollingRight = true;
    }

  }).bind(this)

  getProperty(obj: any, path: string) {
    let value = path?.indexOf('.') > -1 ? path.split('.').reduce((o, p) => o && o[p], obj) : obj[path];
    switch (path) {
      case "moneyDepositEur":
      case "moneyDepositLocal": {
        value = value.toLocaleString(navigator.language);
        break;
      }
    }
    return value;
  }

  getInformation(col: any, element: any) {
    let info = this.getProperty(element, col.key);
    if (["number", "string"].includes(typeof info)) {
      return this.getProperty(element, col.key);
    } else {
      return (col.hasEditable ? (col.key === 'notes' ? this.translateService.instant('PAGES.PRODUCTS.ADD_NOTE') :
        (col.key === 'activities' ? this.translateService.instant('PAGES.PRODUCTS.ADD_ACTIVITY') : '')) : '');
    }
  }

  getInformationTick(element: any, col: any, hasIcon: boolean) {
    if (hasIcon) {
      return element[col];
    }
    return false
  }

  getTooltip(key?: any, element?: any) {
    let tooltip = "";
    if (key === 'isDone') {
      tooltip = this.translateService.instant(('PAGES.PRODUCTS.ACTIVITIES.TOOLTIP.' + (element.isDone ? "DONE" : "TODO")));
    } else if (key === 'activities') {
      tooltip = element.activities;
    } else if (key === 'notes') {
      tooltip = element.notes;
    } else if (key === "trashbin") {
      tooltip = this.translateService.instant('PAGES.DASHBOARD.TOOLTIP_SALE_STATUS_CANCELLED');
    } else if (!element.isInAppointment) {
      if (key === 'logisticStatus') {
        tooltip = this.translateService.instant('PAGES.PRODUCTS.TOOLTIP_LOGISTIC_STATUS');
      }
      if (key === 'liveStatus') {
        tooltip = this.translateService.instant('PAGES.PRODUCTS.TOOLTIP_LIVE_STATUS');
      }
      if (key === 'isAvailableForAllocation') {
        tooltip = this.translateService.instant('PAGES.PRODUCTS.TOOLTIP_ALLOCATION_STATUS');
      }
      if (key === 'isBookedForSales') {
        tooltip = this.translateService.instant('PAGES.DASHBOARD.TOOLTIP_NO_BOOKED_FOR_SALES');
      }

    }
    else {
      tooltip = this.translateService.instant('PAGES.PRODUCTS.TOOLTIP_IN_APPOINTMENT_STATUS');
    }
    return tooltip;
  }

  getStatusValue(status: LogisticStatus): number {
    return LOGISTIC_STATUS_VALUES[status];
  }

  editNote(action: any) {
    if (this.event) {
      this.openEditDialog(action, (event: any) => {
        if (event.field === 'note') {
          let params: ProductUpdaterDTO = {
            notes: event.textValue, // * TO UPDATE !
            logisticStatus: this.getStatusValue(event.element.logisticStatus),
            isAvailableForAllocation: event.element.isAvailableForAllocation,
            isBackup: event.element.isBackup,
            isClientView: event.element.isClientView,
            activities: event.element.activities || '',
            sapCode: event.element.sapCode,
            idHero: this.event!.id
          };
          this.editProduct(params);
        }
        else if (event.field === 'activity') {
          let params: ProductUpdaterDTO = {
            notes: event.element.notes || '',
            logisticStatus: this.getStatusValue(event.element.logisticStatus),
            isAvailableForAllocation: event.element.isAvailableForAllocation,
            isBackup: event.element.isBackup,
            isClientView: event.element.isClientView,
            activities: event.textValue,  // * TO UPDATE !
            sapCode: event.element.sapCode,
            idHero: this.event!.id
          };
          this.editProduct(params);
        }
      });
    }

  }

  editAction(action: any, el: any) {
    if (this.event) {
      this.openEditDialog(action, (event: any) => {
        this.managementService.updateEngravings(this.event!.id, el.sapCode, event.textValue).subscribe(res => {
          this.isLoadingPage = false;
          this.sharedService.openSnackBar(
            this.translateService.instant('PAGES.MANAGEMENT.UPDATE_ENGRAVING_SUCCESS_MESSAGE'), false);
          this.fetchDataHandler.emit(this.setParamsFetch());
        }, err => {
          console.error(err);
          this.sharedService.openSnackBar(
            this.translateService.instant('ERROR_GENERIC_RETRY'),
            true);
        });

      });
    }

  }

  isDisabledButton(col: any, element: any) {
    if (col.hasEditable && this.sharedService.userRole !== RoleEnum.LOGISTIC_READONLY) {
      switch (col.key) {
        case "isClientView": {
          return !element.canUpdateClientView;
        }
        //Posso sempre cambiare il valore di "isBackup" e "sellable"
        case "sellable":
        case "isBackup": {
          return false;
        }
        default: {
          return element.isInAppointment;
        }
      }
    } else {
      return true;
    }
  }

  handleClick(col: any, element: any) {
    if (col.hasEditable) {
      switch (col.key) {
        case "sellable": {
          this.updateSellable(element);
          break;
        }
        case "isAvailableForAllocation": {
          this.updateAvailabilityAllocation(element);
          break;
        }
        case "isBackup": {
          this.updateIsBackup(element);
          break;
        }
        case "isClientView": {
          this.updateIsClientView(element);
          break;
        }
      }
    }
  }

  updateIsClientView(element: any) {
    if (this.event && element.canUpdateClientView) {
      let params: ProductUpdaterDTO = {
        notes: element.notes || '',
        logisticStatus: this.getStatusValue(element.logisticStatus),
        isAvailableForAllocation: element.isAvailableForAllocation,
        activities: element.activities || '',
        isBackup: element.isBackup,
        isClientView: !element.isClientView, // * TO UPDATE !
        sapCode: element.sapCode,
        idHero: this.event!.id
      };
      this.editProduct(params);
    }
  }

  updateIsBackup(element: any) {
    if (this.event) {
      let params: ProductUpdaterDTO = {
        notes: element.notes || '',
        logisticStatus: this.getStatusValue(element.logisticStatus),
        isAvailableForAllocation: element.isAvailableForAllocation,
        activities: element.activities || '',
        isBackup: !element.isBackup, // * TO UPDATE !
        isClientView: element.isClientView,
        sapCode: element.sapCode,
        idHero: this.event!.id
      };
      this.editProduct(params);
    }
  }

  updateAvailabilityAllocation(element: any) {
    if (this.event) {
      let params: ProductUpdaterDTO = {
        notes: element.notes || '',
        logisticStatus: this.getStatusValue(element.logisticStatus),
        isAvailableForAllocation: !element.isAvailableForAllocation,  // * TO UPDATE !
        isBackup: element.isBackup,
        isClientView: element.isClientView,
        activities: element.activities || '',
        sapCode: element.sapCode,
        idHero: this.event!.id
      };
      this.editProduct(params);
    }
  }

  updateSellable(element: Watch) {
    if (this.event) {
      this.managementService.updateSellable(this.event.id, element.sapCode).subscribe(res => {
        this.isLoadingPage = false;
        this.sharedService.openSnackBar(
          this.translateService.instant('ROW_UPDATED'), false);
        element.sellable = !element.sellable;
      }, err => {
        console.error(err);
        this.sharedService.openSnackBar(
          this.translateService.instant('ERROR_GENERIC_RETRY'),
          true);
      });
    }

  }

  updateLogisticStatus(element: any, status: LogisticStatus, i: number) {
    if (this.event && element.canUpdateLogisticStatus) {
      this.loadingRow = i;
      let params: ProductUpdaterDTO = {
        notes: element.notes || '',
        logisticStatus: this.getStatusValue(status),
        isAvailableForAllocation: element.isAvailableForAllocation,
        isBackup: element.isBackup,
        isClientView: element.isClientView,
        activities: element.activities || '',
        sapCode: element.sapCode,
        idHero: this.event!.id
      };
      this.editProduct(params);
    }
  }

  openEditDialog(action: any, handler: Function) {
    const dialogRef = this.dialog.open(EditDialogComponent, {
      data: action,
      width: '50em',
      // height: '20em',
      backdropClass: 'bdrop'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        handler(result, action);
      }
    });
  }

  sortData(sort: Sort) {
    this.sortRules = sort;
    this.fetchDataHandler.emit(this.setParamsFetch());
  }

  handlePageEvent(e: PageEvent) {
    this.pageIndex = e.pageIndex;
    this.fetchDataHandler.emit(this.setParamsFetch());
  }

  setParamsFetch() {
    let params: any = {}
    params.OrderBy = this.sortRules?.active;
    params.isDesc = this.sortRules?.direction === 'desc' ? true : false;
    params.Limit = this.limit;
    params.Skip = this.pageIndex * this.limit;
    params.pageIndex = this.pageIndex;
    params.Status = this.searchResult && this.searchResult.status ? this.searchResult.status : null;
    params.Search = this.searchResult && this.searchResult.search ? this.searchResult.search : '';
    params.SapCode = this.searchResult && this.searchResult.sapCodes ?
      this.searchResult.sapCodes.trim().replace(/[&\/\\#,+()$~%.'":*?<>{},\D+]/g, " ").split(' ') : null;
    params.sortRules = this.sortRules;
    return params;
  }

  editProduct(params: any) {
    // this.isLoadingPage = true;
    this.logisticService.updateProduct(params).subscribe(res => {
      // this.isLoadingPage = false;
      this.loadingRow = -1;
      this.sharedService.openSnackBar(this.translateService.instant('ROW_UPDATED'), false);
      this.updateRow(params, res);
    }, err => {
      // this.isLoadingPage = false;
      this.loadingRow = -1;
      console.error(err);
      this.sharedService.openSnackBar(
        this.translateService.instant('ERROR_GENERIC_RETRY'),
        true);
    });

  }

  updateRow(params: any, value: any) {
    let index = this.data.findIndex((e: any) => e.sapCode == params.sapCode);
    if (!Number.isNaN(index)) {
      this.data[index].notes = value.notes;
      this.data[index].logisticStatus = value.logisticStatus;
      this.data[index].activities = value.activities;
      this.data[index].isAvailableForAllocation = value.isAvailableForAllocation;
      this.data[index].isBackup = value.isBackup;
      this.data[index].isClientView = value.isClientView;
      this.data[index].isClientView = value.isClientView;
      this.data[index].allocation = value.allocation;
      this.data[index].allocationStatus = value.allocationStatus;
      this.data[index].canUpdateClientView = value.canUpdateClientView;
      this.data[index].canUpdateLogisticStatus = value.canUpdateLogisticStatus;
      this.data[index].salesTeamStatus = value.salesTeamStatus;
      //TODO: Testare l'aggiornamento di salesTeamStatus al variare di STATUS e rilasciare in PROD

      this.dataSource = this.data.map((elem: any) => {
        return elem;
      });
    }
  }

  openDashboardDetailDialog(data: any) {
    this.iconAction.emit(data);
  }

  deleteBookedForSales(element: Sale) {
    this.sharedService.openDeleteDialog(this.translateService.instant('PAGES.DASHBOARD.DELETE_BOOKED_FOR_SALES') + ' ' + element.sapCode,
      this.translateService.instant('PAGES.DASHBOARD.DELETE_BOOKED_FOR_SALES_MESSAGE'),
      element,
      () => {
        this.iconAction.emit(element);
      })
  }

  trashbinIsDisabled(element: Sale) {
    return element.salesStatus && element.salesStatus === SaleStatus.CANCELLED
  }

  financeIconAction(element: any, isExportAction?: boolean) {
    this.iconAction.emit({ ...element, isExporting: isExportAction });
  }

}
